
export const useProductImages = () => {
  const getImageUrl = (fileName) => {
    if (!fileName) return null
    return `/images/products/${fileName}`
  }

  const getSortedVariantImages = (variantImages) => {
    if (!variantImages || !Array.isArray(variantImages)) return []
    return variantImages
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map(img => ({
        imageName: img.imageName,
        displayOrder: img.displayOrder,
        isPrimary: img.isPrimary,
        url: getImageUrl(img.imageName)
      }))
  }

  return {
    getImageUrl,
    getSortedVariantImages
  }
}
